import { getDuration } from "utils/dateAndTime";

export const convertAttrubutesToHumanReadableFormat = (data) => {
    if (data) {
        const attributesWithHumanReadableKey = Object.keys(data).reduce((acc, key) => {
            acc[key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())] =
                data[key];
            return acc;
        }, {});
        return attributesWithHumanReadableKey;
    }
    return {};
};

const converObjectToFlatObjectWithIndex = (data) => {
    if (data) {
        const flatObject = Object.keys(data).reduce((acc, key) => {
            if (typeof data[key] === "object") {
                const nestedObject = converObjectToFlatObjectWithIndex(data[key]);
                Object.keys(nestedObject).forEach((nestedKey) => {
                    acc[`${nestedKey} ${key}`] = nestedObject[nestedKey];
                });
            } else {
                acc[key] = data[key];
            }
            return acc;
        }, {});

        return flatObject;
    }
    return {};
};

export const mapUpdateProjectInfoToMixPanel = (data, projectId, projectStatus) => {
    const flatData = converObjectToFlatObjectWithIndex(data);
    const mixPanelData = {
        projectId,
        projectStatus,
        ...flatData,
    };
    return convertAttrubutesToHumanReadableFormat(mixPanelData);
};

const mapSalesCreationDataToMixPanel = (data, timeOpened) => {
    const attributes = data?.attributes;
    // this line to exclude projectTruckTypes object from the data
    const { projectTruckTypes } = attributes;
    const truckTypes = projectTruckTypes?.map((truckType, index) => {
        // add woring condition index to every truck type attribute keyname as apostfix
        const truckTypeAttributesWithIndex = Object.keys(truckType).reduce((acc, key) => {
            acc[`${key} ${index + 1}`] = truckType[key];
            return acc;
        }, {});
        return truckTypeAttributesWithIndex;
    });
    // convert attributes keyname from camelcase to human readable format
    const attributesWithHumanReadableKey = convertAttrubutesToHumanReadableFormat(attributes);

    // convert truckTypeAttributesWithIndex keyname from camelcase to human readable format
    const workingConditions = truckTypes?.map((truckType) =>
        convertAttrubutesToHumanReadableFormat(truckType)
    );

    const duration = getDuration(timeOpened, new Date());

    return {
        ...attributesWithHumanReadableKey,
        // extract attributes from every truck type item in truckTypeAttributesWithIndex array and add it to the main object
        ...workingConditions.reduce((acc, truckType) => ({ ...acc, ...truckType }), {}),
        // exculde projectTruckTypes object from the data
        "Project Truck Types": undefined,
        "Time Taken to Create Project": duration,
    };
};

export const mapSupplierWorkingConditionsDataToMixPanel = (
    data,
    updatedSupplier,
    projectId,
    projectStatus,
    workingConditionStatus
) => {
    const readableFullFillmentDetails = convertAttrubutesToHumanReadableFormat(
        data?.fullFillmentDetails
    );
    const readablePricingDetails = convertAttrubutesToHumanReadableFormat(data?.pricingDetails);
    const flatUpdatedSupplier = convertAttrubutesToHumanReadableFormat(
        converObjectToFlatObjectWithIndex(updatedSupplier)
    );

    return {
        ...readableFullFillmentDetails,
        ...readablePricingDetails,
        ...flatUpdatedSupplier,
        "Project Id": projectId,
        "Project Status": projectStatus,
        "Working Condition Status": workingConditionStatus,
    };
};

export const mapSalesWorkingConditionsDataToMixPanel = (
    data,
    projectStatus,
    workingConditionStatus
) => {
    const mixPanelData = {
        ...data,
        projectStatus,
        workingConditionStatus,
        ...(data?.salesChannels && {
            salesChannels: data?.salesChannels?.map((channel) => channel?.label),
        }),
        ...(data?.serviceAreas && { serviceAreas: data?.serviceAreas?.map((area) => area?.label) }),
        ...(data?.salesChannels && {
            weeklyOffDays: data?.weeklyOffDays?.map((day) => day?.label),
        }),
    };
    return convertAttrubutesToHumanReadableFormat(mixPanelData);
};

export default mapSalesCreationDataToMixPanel;
